import { useState } from 'react';
import { toast } from 'react-toastify';
import PageHeader from './Common/PageHeader';

function DeleteAccount() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    reason: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Simulate API call
    console.log('Account Deletion Request Submitted:', formData);

    toast.success('Request sent. We’ll contact you soon.', { autoClose: 3000 });

    // Reset the form
    setFormData({
      name: '',
      phone: '',
      email: '',
      reason: '',
    });
  };

  return (
    <>
      <PageHeader title="Delete Account" />
      <div className="container my-5">
        <div className="card shadow-lg border-0">
          <div className="card-body p-4">
            <h3 className="card-title mb-4 fw-bold">
              Request Account Deletion
            </h3>
            <p className="text-muted mb-4">
              Please fill in the form below to request the deletion of your
              account. Once submitted, our team will verify your details and
              confirm the deletion via email or phone.
            </p>

            <form onSubmit={handleSubmit}>
              {/* Name */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Full Name</label>
                <input
                  placeholder="Enter your full name"
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Phone */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Phone Number</label>
                <input
                  placeholder="Enter your phone number "
                  type="tel"
                  name="phone"
                  className="form-control"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Email */}
              <div className="mb-3">
                <label className="form-label fw-semibold">Email Address</label>
                <input
                  placeholder="Enter your email address"
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Reason */}
              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Reason for Account Deletion
                </label>
                <textarea
                  placeholder="Briefly explain why you wish to delete your account..."
                  name="reason"
                  className="form-control"
                  rows="4"
                  value={formData.reason}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="button border-0 w-100 fw-semibold py-2"
              >
                Submit Deletion Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeleteAccount;
